import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';

import {
  loadRequest,
  loadSuccess,
  loadFailure,
  itensNotaSecundariasRequest,
  itensNotaSecundariasSuccess,
  itensNotaSecundariasFailure,
} from './actions';

export function* loadMovimentacoesSaida({ payload }: ReturnType<typeof loadRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getPedidos&pagina=${
        payload.pagination ? payload.pagination?.current - 1 : 0
      }&tamanhoPagina=${payload.pagination ? payload.pagination?.pageSize : 5}&token=${
        state.auth.token
      }`,
      {
        codCdd: payload.cddAtivo,
        filtro: payload.filtro,
        parceiros: payload.inscricaoAtiva,
        ordenacao: payload.sorter,
      }
    );
    yield put(
      loadSuccess(response.data.pedidos, {
        total: response.data.total,
        current: payload.pagination?.current || 0 + 1,
        pageSize: payload.pagination?.pageSize || 5,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20', '50'],
      })
    );
  } catch (error: any) {
    yield put(loadFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar as movimentações de saída, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}

export function* loadItensNotaSecundarias({
  payload,
}: ReturnType<typeof itensNotaSecundariasRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getNotasSecundarias&token=${state.auth.token}`,
      { nuNota: payload.nuNota, centroDistribuicao: payload.centroDistribuicao }
    );
    yield put(itensNotaSecundariasSuccess(response.data.notas));
  } catch (error: any) {
    yield put(itensNotaSecundariasFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar os itens da nota, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
